<template>
  <v-container fluid>
    <QuoteDetailsVue
      :currencies="currencies"
      :quotation_id="$route.params.quotation_id"
      :supplier_id="$route.params.supplier_id"
      :itbis="itbis"
    />
  </v-container>
</template>

<script>
import QuoteDetailsVue from "@/components/Shop/QuoteDetails.vue";
export default {
  data() {
    return {
      quote: [],
      currencies: [],
      itbis: [],
    };
  },
  components: { QuoteDetailsVue },

  created() {
    this.init();
  },
  methods: {
    async init() {
      let response = await this.api_Get("accounting/taxes");
      this.itbis = await response.json();
      this.currencies = await this.g_currencies();
    },
  },
};
</script>
